import React from 'react';
import ReactMarkdown from 'react-markdown';

import { useGetConsultationHomeworkQuery } from '../../services/consultation-results.api';

import { AiAssistantDisclaimer } from './ai-assistant-disclaimer';
import { AiAssistantMissingMessage } from './ai-assistant-missing-message';

type Props = {
  consultationId?: number;
  isGroupConsultation?: boolean;
};

export const AiHomeworkTab = ({ consultationId, isGroupConsultation = false }: Props) => {
  const hasConsultationId = Boolean(consultationId);
  const { data, isFetching, isLoading, isError } = useGetConsultationHomeworkQuery(
    consultationId ? consultationId.toString() : '',
    { skip: !hasConsultationId },
  );

  const renderCard = (children: React.ReactNode, variant: 'default' | 'error' = 'default') => {
    const baseClasses = 'p-1 lg:p-1 text-body-l lg:text-body-xl leading-relaxed space-y-4';
    const variantClasses = variant === 'error' ? 'text-primary' : 'text-ink-muted';

    return <div className={`${baseClasses} ${variantClasses}`}>{children}</div>;
  };

  if (!hasConsultationId) {
    return renderCard(<>Выберите запись, чтобы увидеть ИИ домашнее задание.</>);
  }

  if (isLoading || isFetching) {
    return renderCard(<p>Загружаем ИИ домашнее задание...</p>);
  }

  if (isError || !data?.homework) {
    return renderCard(
      <AiAssistantMissingMessage assistant="ai-homework" isGroupConsultation={isGroupConsultation} />,
      'error',
    );
  }

  return renderCard(
    <div className="text-ink text-ui lg:text-body-l leading-relaxed">
      <ReactMarkdown
        components={{
          p: (paragraphProps) => <p className="mt-3 mb-1 last:mb-0" {...paragraphProps} />,
        }}
      >
        {data.homework}
      </ReactMarkdown>
      <AiAssistantDisclaimer assistant="ai-homework" />
    </div>,
  );
};
